// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @9/3/2021 7:16:00 AM
import { PersistentObject } from '../../../SagaBase/PersistentObject';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ListCountries_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.ListObjects.ListCountries';
  $t: string = 'SagaSchema.ListObjects.ListCountries';

  public static GetMembers(): string[] {
    return ['CountryId', 'Country', 'CountryCode', 'Deleted', 'Priority', 'Name', 'Value'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return ListCountries_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public CountryId: number = 0;
  public Country: string;
  public CountryCode: string;
  public Deleted: boolean = false;
  public Priority: number = 0;
  public Name: string;
  public Value: any;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.CountryId;
  }
  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
